import { create } from 'zustand'
import { apiFetch } from '../utils/api';

const normalizarPartida = (partida) => {
    const fecha = partida.fecha ? new Date(partida.fecha) : null;
    const fin = fecha ? new Date(fecha.getTime() + (partida.duracion || 0) * 60 * 1000) : null;
    const jugadores = Array.isArray(partida.jugadores) ? partida.jugadores : [];
    const creador = partida.creador || jugadores.find((jugador) => jugador?.userId === partida.createdByUserId) || jugadores[0] || {};
    const nombreCreador = `${creador.nombre || ""} ${creador.apellido || ""}`.trim() || creador.nombre || partida.titulo || "";

    return {
        ...partida,
        ID_MAT: partida.id,
        DIA_MAT: partida.fecha,
        INICIO_HORA: fecha ? fecha.toTimeString().slice(0, 8) : "",
        FIN_HORA: fin ? fin.toTimeString().slice(0, 8) : "",
        NOMBRE_CAN: partida.cancha?.nombre || partida.court?.nombre || "",
        NUMERO_CANCHA_CAN: "",
        NOMBRE_SUCURSAL_SUC: partida.sucursal?.nombre || partida.branch?.nombre || "",
        NOMBRE_COMPLETO: nombreCreador,
        CORREO_DP: creador.email || "",
        TELEFONO_DP: creador.telefono || "",
        NIVEL_MAT: partida.nivel || "",
        CATEGORIA_MAT: partida.categoria || partida.formato || "",
        CURRENT_PLAYERS_MAT: jugadores.length,
        MAX_PLAYERS_MAT: partida.limiteJugadores,
        COMENTARIOS_MAT: partida.comentarios || "",
    };
};

const useAprobarPartidasStore = create((set) => ({
    isLoading: true,
    error: "",
    partidas: [],
    iniciar: async() => {
        if (localStorage.getItem('isLoggedIn') === 'true') {
            set({ isLoading: true, error: "" });
            try {
                const data = await apiFetch("/api/matches/pending-approval");
                if (data['status']) {
                    const partidas = Array.isArray(data['data']) ? data['data'].map(normalizarPartida) : [];
                    set({partidas});
                } else {
                    set({partidas: [], error: data.message || "No se pudieron cargar las partidas pendientes."});
                }
            } catch (error) {
                console.error('Error:', error);
                set({partidas: [], error: error.message || "No se pudieron cargar las partidas pendientes."});
            } finally {
                set({isLoading: false});
            }
        }
    },
    aprobarPartida: async(id) => {
        try {
            const data = await apiFetch(`/api/matches/${id}/approve`, {
                method: "POST",
            });
            if (data.status) {
                set((state) => ({
                    partidas: state.partidas.filter(p => p.id !== id)
                }));
                return { success: true, message: data.message };
            }
            return { success: false, message: data.message };
        } catch (error) {
            console.error('Error:', error);
            return { success: false, message: "Error al aprobar la partida" };
        }
    },
    cancelarPartida: async(id) => {
        try {
            const data = await apiFetch(`/api/matches/${id}/cancel`, {
                method: "POST",
            });
            if (data.status) {
                set((state) => ({
                    partidas: state.partidas.filter(p => p.id !== id)
                }));
                return { success: true, message: data.message };
            }
            return { success: false, message: data.message };
        } catch (error) {
            console.error('Error:', error);
            return { success: false, message: "Error al cancelar la partida" };
        }
    }
}))

export default useAprobarPartidasStore
